































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { UserInfo } from '../../_models/userInfo'

@Component
export default class DetailsApprendistato extends Vue {
    @Prop() info!: any;

    get isDittaIndividuale() {
        var valid = false;
        valid = /^[a-zA-Z]{6}[a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{2}[a-zA-Z][a-zA-Z0-9]{3}[a-zA-Z]$/.test(
            this.info.pIva
        );
        return valid;
    }

}
